
import api from '@/api';

const namespaced = true;

const state = {
  statuses: [],
};

const mutations = {
  SET_STATUSES(state, statuses) {
    state.statuses = statuses;
  },
  ADD_STATUS(state, status) {
    state.statuses.splice(state.statuses.length - 1, 0, status);
  },
  SAVE_STATUS(state, status) {
    state.statuses.splice(status.sort - 1, 1, status);
  },
  DELETE_STATUS(state, deleteStatus) {
    let index = -1;
    state.statuses.forEach((status, i) => {
      if (deleteStatus.id === status.id) {
        index = i;
      }
    });
    state.statuses.splice(index, 1);
  },
};

const actions = {
  async fetchStatuses({ commit }) {
    const { data: statuses } = await api.get(`/statuses`);

    commit(`SET_STATUSES`, statuses);

    return statuses;
  },
  async fetchListForMaker(store, makerId) {
    const { data: statuses } = await api.get(`/statuses/maker/${makerId}`);

    return statuses;
  },
  async addStatus({ commit, rootState }, status) {
    const makerId = status.makerId || rootState[`model/client`].company.id;
    const { data: newStatus } = await api.post(`/statuses/maker/${makerId}`, status);

    commit(`ADD_STATUS`, newStatus);
  },
  async saveStatus({ commit }, status) {
    try {
      const { data: newStatus } = await api.put(`/statuses/${status.id}`, status);
      commit(`SAVE_STATUS`, newStatus);
    } catch (e) { } // eslint-disable-line
  },
  async deleteStatus({ commit }, status) {
    try {
      await api.delete(`/statuses/${status.id}`, status);
      commit(`DELETE_STATUS`, status);
    } catch (e) { } // eslint-disable-line
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
